import type { FeedbackCollectorConfig } from '../types/feedbackCollector';

let cachedFeedbackCollectorConfig: FeedbackCollectorConfig | null = null;

export const configService = {
  async getFeedbackCollectorConfig(): Promise<FeedbackCollectorConfig> {
    if (cachedFeedbackCollectorConfig) {
      return cachedFeedbackCollectorConfig;
    }

    // Account token should be set via VITE_FEEDBACK_COLLECTOR_ACCOUNT_TOKEN environment variable
    // or in the feedbackCollector.config.json file
    const accountTokenFromEnv = import.meta.env.VITE_FEEDBACK_COLLECTOR_ACCOUNT_TOKEN ?? 'iy1dtuko6r9mivpjmfisz46of1d136d6';

    const defaultFeedbackCollectorConfig: FeedbackCollectorConfig = {
      baseUrl: 'https://mfe.workspace.accessacloud.com/registry/evo-feature-feedback-collector/1/',
      accountToken: '',
      product: 'Access Assets',
    };

    try {
      const response = await fetch('/config/feedbackCollector.config.json');
      if (!response.ok) {
        console.warn('Feedback collector config not found, using defaults');
        return defaultFeedbackCollectorConfig;
      }

      const configFromFile = await response.json();
      cachedFeedbackCollectorConfig = {
        ...configFromFile,
        accountToken: accountTokenFromEnv || configFromFile.accountToken || '',
      };
      return cachedFeedbackCollectorConfig!;
    } catch (error) {
      console.error('Failed to load feedback collector config:', error);
      return defaultFeedbackCollectorConfig;
    }
  },

  clearCache(): void {
    cachedFeedbackCollectorConfig = null;
  },
};
